type Props = {
  label: string;
  value: string | number;
  hint?: string;
  className?: string;
};

const StatTile = ({ label, value, hint, className = "" }: Props) => (
  <div className="bg-base-200 rounded-box px-3 py-2 min-w-0">
    <div className="text-xs text-base-content/60 truncate">{label}</div>
    <div className={`text-xl font-bold ${className}`}>
      {typeof value === "number" ? value.toLocaleString() : value}
    </div>
    {hint && <div className="text-xs text-base-content/50 truncate">{hint}</div>}
  </div>
);

export default StatTile;
